import React, { useEffect, useState } from "react";
import { Form, Button} from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Login.css";
import "../css/Register.css";

export default function Login() {
    const [emailUser, setEmailUser] = useState();
    const [passwordUser, setPasswordUser] = useState();
    const [passError, setPassError] = useState();
    let navigate = useNavigate();

    const handleEmailUser = (e) => {
        setEmailUser(e.target.value);
        console.log(emailUser);
    };

    const handlePasswordUser = (e) => {
        setPasswordUser(e.target.value);
        console.log(passwordUser);
    };

    const redirectReg = () => {
        navigate("/SelectRegister");
    };

    const redirectRSO = () => {
        navigate("/MyUniversity");
    };

    async function handleLogin() {
        try {
            let info = {
                email: emailUser,
                password: passwordUser,
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/login.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                /*global.userid = res.id;
                global.first = res.firstName;
                global.last = res.lastName;
                global.email = res.email;
                global.uniid = res.uniid;
                global.adminorsuper = res.adminorsuper;*/

                console.log("This is the start of global variables");
                /* console.log(global.userid);
                console.log(global.first);
                console.log(global.last);
                console.log(global.email);
                console.log(global.uniid);
                console.log(global.adminorsuper); */
                localStorage.setItem("userid", res.id);
                localStorage.setItem("first", res.firstName);
                localStorage.setItem("last", res.lastName);
                localStorage.setItem("email", res.email);
                localStorage.setItem("uniid", res.uniid);
                localStorage.setItem("adminorsuper", res.adminorsuper);
                redirectRSO();
            } else {
                console.log("Login failed :(");
                setPassError(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="login">
            <div className="ui center aligned padded grid register-box">
                <div className="row">
                    <div className="register-blue-sidebar column five wide">
                        <h2 className="register-app-title">Student Events</h2>
                    </div>
                    <div className="login-box column eleven wide">
                        <div>
                            <h1 className="login-header">WELCOME BACK</h1>
                            <Form size={"massive"} onSubmit={handleLogin}>
                                <div className="login-input">
                                    <Form.Input
                                        fluid
                                        placeholder="Email"
                                        required
                                        onChange={handleEmailUser}
                                    />
                                </div>
                                <div className="login-input">
                                    <Form.Input
                                        fluid
                                        placeholder="Password"
                                        type="password"
                                        required
                                        onChange={handlePasswordUser}
                                        // error = {passError}
                                    />
                                </div>
                                <div className="login-error">
                                    {passError !== "" ? passError : ""}
                                </div>
                                <div className="login-button">
                                    <Button className="login-btn">
                                        LOGIN
                                    </Button>
                                </div>
                            </Form>
                            <a
                                className="login-register-link"
                                onClick={redirectReg}
                            >
                                New here? Create an account
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
